import { Link } from 'react-router-dom'
import { getFullPath } from '../helpers/path'
import { getStatusTone, statusLabels, VehicleStatuses } from '../helpers/status'
import { IconCar, IconPin } from './Icons'
import type { Vehicle } from '../types'
import './VehicleCard.css'

type Props = {
  vehicle: Vehicle
  compact?: boolean
}

export function VehicleCard({ vehicle, compact }: Props) {
  const tone = getStatusTone(vehicle.status)
  const brandIcon = getFullPath('brands', vehicle.brandId?.icon)
  const onboarding =
    vehicle.status === VehicleStatuses.Created ||
    vehicle.status === VehicleStatuses.Plan ||
    vehicle.status === VehicleStatuses.Payment

  const to = onboarding ? `/app/vehicles/${vehicle._id}/onboard` : `/app/vehicles/${vehicle._id}`

  return (
    <Link to={to} className={`vcard${compact ? ' vcard--compact' : ''}`} state={{ vehicle }}>
      <div className="vcard__top">
        {brandIcon ? (
          <img src={brandIcon} alt="" className="vcard__icon" />
        ) : (
          <span className="vcard__icon vcard__icon--fallback">
            <IconCar size={16} />
          </span>
        )}
        <strong className="vcard__name">{vehicle.name}</strong>
        <span className="vcard__badge" style={{ background: tone.bg, color: tone.color }}>
          {statusLabels[vehicle.status] ?? vehicle.status}
        </span>
      </div>
      <div className="plate-chip">{vehicle.plateNumber}</div>
      {vehicle.latestPosition?.address && (
        <p className="vcard__address">
          <IconPin size={14} />
          <span>{vehicle.latestPosition.address}</span>
        </p>
      )}
    </Link>
  )
}
